require('./dropdown-menu.js');
require('./widget-chart.js');
require('./widget-empty.js');
require('./widget-error.js');
require('./widget-footer.js');
require('./widget-menu.js');
require('./widget-report.js');
require('./widget-spinner.js');
require('./widget-wrapper.js');
